import React from "react";
import { LifeBuoy } from "lucide-react";

const SupportIcon = (props: any) => <LifeBuoy {...props} />;

export default SupportIcon;
